import createLucideIcon from '../createLucideIcon';

const Dot = createLucideIcon('Dot', [
  ['circle', { cx: '12.1', cy: '12.1', r: '1', key: '18d7e5' }],
]);

export default Dot;
